<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptitlef"><a id="page_3"></a><span class="ts2">CONTENTS</span></h1>
<h2 class="chapEntryf"><a href="#/xhtml/06_time">Timeline</a></h2>
<h2 class="chapEntryf"><a href="#/xhtml/07_intro">Introduction</a></h2>
<h2 class="chapEntryf"><span href="#/xhtml/08_prologue" title="Link target outside of Sample">Prologue</span></h2>
<h2 class="chapEntry"><span href="#/xhtml/09_ch01" title="Link target outside of Sample"><span class="tt1">1.</span> Background</span></h2>
<h2 class="chapEntry"><span href="#/xhtml/10_ch02" title="Link target outside of Sample"><span class="tt1">2.</span> A Dirty, Distant War</span></h2>
<h2 class="chapEntry"><span href="#/xhtml/11_ch03" title="Link target outside of Sample"><span class="tt1">3.</span> First Impressions</span></h2>
<h2 class="chapEntry"><span href="#/xhtml/12_ch04" title="Link target outside of Sample"><span class="tt1">4.</span> Covering the War</span></h2>
<h2 class="chapEntry"><span href="#/xhtml/13_ch05" title="Link target outside of Sample"><span class="tt1">5.</span> More American Involvement</span></h2>
<h2 class="chapEntry"><span href="#/xhtml/14_ch06" title="Link target outside of Sample"><span class="tt1">6.</span> The Legend of the Bearded One</span></h2>
<h2 class="chapEntry"><span href="#/xhtml/15_ch07" title="Link target outside of Sample"><span class="tt1">7.</span> Military Advisory Group</span></h2>
<h2 class="chapEntry"><span href="#/xhtml/16_ch08" title="Link target outside of Sample"><span class="tt1">8.</span> Central American Crisis</span></h2>
<h2 class="chapEntry"><span href="#/xhtml/17_ch09" title="Link target outside of Sample"><span class="tt1">9.</span> No Man’s Land</span></h2>
<h2 class="chapEntry1"><span href="#/xhtml/18_ch10" title="Link target outside of Sample"><span class="tt2">10.</span> US Military Assistance Command</span></h2>
<h2 class="chapEntryf"><span href="#/xhtml/19_notes" title="Link target outside of Sample">Notes</span></h2>
<h2 class="chapEntryf"><span href="#/xhtml/20_bib" title="Link target outside of Sample">Bibliography</span></h2>
<h2 class="chapEntryf"><span href="#/xhtml/21_ack" title="Link target outside of Sample">Acknowledgements</span></h2>
<h2 class="chapEntryf"><span href="#/xhtml/22_author" title="Link target outside of Sample">About the Author</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?5634f887